import { LocalDate } from '@js-joda/core';

import { Country } from '@dreryk/address-common-api';
import { AuthorizedPersonExternalIdentifier } from '@dreryk/egabinet-patient-published-language-api';
import { NationalIdentificationNumberCountry } from '@dreryk/personal-external-identifier-common-api';

import {
   AuthorizedPersonIdentifierType,
   authorizedPersonIdentifierVisitor,
} from './AuthorizedPersonIdentifierTypeField';
import { AuthorizedPersonIdentifierValue } from './AuthorizedPersonIdentifierValueField';

export type AuthorizedPersonIdentifierFormBean = {
   birthDate: LocalDate | null;
   authorizedPersonIdentifierType: AuthorizedPersonIdentifierType;
   authorizedPersonIdentifierValue: AuthorizedPersonIdentifierValue;
   passportCountry: Country | null;
   passportValidTo: LocalDate | null;
   nationalIdentificationNumberCountry: NationalIdentificationNumberCountry | null;
};

export const createAuthorizedPersonIdentifierFormBean = (
   externalIdentifier: AuthorizedPersonExternalIdentifier | undefined,
   birthDate: LocalDate | undefined
): AuthorizedPersonIdentifierFormBean => {
   return authorizedPersonIdentifierVisitor(
      externalIdentifier,
      birthDate
   )<AuthorizedPersonIdentifierFormBean>({
      visitBirthDate: (birthDate) => ({
         birthDate: birthDate,
         authorizedPersonIdentifierType: 'BirthDate',
         authorizedPersonIdentifierValue: null,
         nationalIdentificationNumberCountry: null,
         passportCountry: null,
         passportValidTo: null,
      }),
      visitPesel: (pesel) => ({
         authorizedPersonIdentifierType: 'Pesel',
         authorizedPersonIdentifierValue: pesel.asString(),
         nationalIdentificationNumberCountry: null,
         passportCountry: null,
         passportValidTo: null,
         birthDate: null,
      }),
      visitPassport: (passport) => ({
         authorizedPersonIdentifierType: 'Passport',
         authorizedPersonIdentifierValue: passport.getValue(),
         passportCountry: passport.getCountry(),
         passportValidTo: passport.getValidTo(),
         nationalIdentificationNumberCountry: null,
         birthDate: null,
      }),
      visitNationalIdentificationNumber: (nationalIdentificationNumber) => ({
         authorizedPersonIdentifierType: 'NationalIdentificationNumber',
         authorizedPersonIdentifierValue: nationalIdentificationNumber.getValue(),
         nationalIdentificationNumberCountry: nationalIdentificationNumber.getCountry(),
         passportCountry: null,
         passportValidTo: null,
         birthDate: null,
      }),
   });
};
